import React from 'react';
import { CheckIcon } from 'lucide-react';
import { isThis } from '../data/copy';
export function SolutionSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14" aria-labelledby="solution-heading" data-id="element-168" data-mp="3aaud1j8wphh0">
      <div className="mx-auto max-w-5xl px-6" data-id="element-169" data-mp="3oabsv9485ke8">
        <div className="rounded-4xl border border-line bg-shell px-7 py-10 shadow-soft sm:px-12" data-id="element-170" data-mp="3o6xuebyolvc2">
          <div className="text-center" data-id="element-171" data-mp="3jck42nyvmee9">
            <p className="flex items-center justify-center gap-4 font-sans text-xs font-semibold uppercase tracking-[0.22em] text-lime-ink" data-id="element-172" data-mp="13t3vznth7x0">
              <span className="h-px w-10 bg-lime-ink/40" aria-hidden="true" data-id="element-173" data-mp="3t6aqlnbg0erb" />
              Introducing
              <span className="h-px w-10 bg-lime-ink/40" aria-hidden="true" data-id="element-174" data-mp="awi7y9h1fjib" />
            </p>

            <h2 id="solution-heading" className="mt-6 font-display text-[1.9rem] font-extrabold leading-[1.08] text-ink sm:text-[2.6rem]" data-id="element-175" data-mp="5xe2ntx8i5x9">
              The Pickleball Instructor’s Vault™
            </h2>
            <p className="mx-auto mt-3 max-w-xl font-display text-lg font-bold leading-snug text-navy sm:text-xl" data-id="element-176" data-mp="fre5fp51mz2t">
              A complete 6-in-1 coaching operating system.
            </p>
            <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-177" data-mp="3b9yv8je98rcc">
              Not a collection of random internet clips. Not a theoretical
              manual that needs rewriting. A professional architecture, so you
              can walk onto any court, with any level of student, and deliver an
              elite experience every single time.
            </p>
          </div>

          <ul className="mx-auto mt-8 grid max-w-3xl gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-178" data-mp="3u68c1egjjw01">
            {isThis.map(item => <li key={item} className="flex items-start gap-3 font-sans text-[0.9rem] leading-relaxed text-ink/85" data-id="element-179" data-mp="6vh7uk20aj88">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime-ink" strokeWidth={2.6} aria-hidden="true" data-id="element-180" data-mp="bv3lgulqy1hk" />
                {item}
              </li>)}
          </ul>

          <p className="mt-9 text-center font-display text-base font-bold uppercase tracking-[0.16em] text-lime-ink sm:text-lg" data-id="element-181" data-mp="grc1093uvwp9">
            Solve a full year of coaching in 5 minutes.
          </p>
        </div>
      </div>
    </section>;
}